import gql from "graphql-tag";

export const GET_USER_ACCESS_DETAILS = gql`
  query ($userEmail: String) {
    getUserAccessDetails(userEmail: $userEmail) {
      statusCode
      message
      data
    }
  }
`;

export const GET_RECORD_ACCESS_RULES = gql`
  query {
    getRecordAccessRules {
      statusCode
      message
      data
    }
  }
`;

export const UPDATE_ACCESS_RULE_BY_ID = gql`
  mutation (
    $id: String!
    $name: String!
    $description: String!
    $permissions: String!
    $userGroups: String!
  ) {
    updateRecordAccessRule(
      id: $id
      name: $name
      description: $description
      permissions: $permissions
      userGroups: $userGroups
    ) {
      statusCode
      data
      message
    }
  }
`;

export const ADD_NEW_ACCESS_RULE = gql`
  mutation (
    $name: String!
    $description: String!
    $permissions: String!
    $userType: String!
    $userGroups: String!
    $userLocations: String!
  ) {
    addRecordAccessRule(
      name: $name
      description: $description
      permissions: $permissions
      userType: $userType
      userGroups: $userGroups
      userLocations: $userLocations
    ) {
      statusCode
      message
    }
  }
`;

export const REMOVE_ACCESS_RULE_BY_ID = gql`
  mutation ($id: String!) {
    removeRecordAccessRule(id: $id) {
      statusCode
      data
      message
    }
  }
`;

export const GET_ALL_USER_GROUPS = gql`
  query {
    getAllUserGroups {
      statusCode
      message
      data
    }
  }
`;
